import { authService } from '@services/api';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useMfaStatus = () => {
  return useQuery({
    queryKey: ['mfa', 'status'],
    queryFn: () => authService.getMfaStatus({}),
    staleTime: 30_000,
  });
};

export const useBeginMfaEnrollment = () => {
  return useMutation({
    mutationFn: () => authService.beginMfaEnrollment({ method: 'totp' }),
  });
};

export const useCompleteMfaEnrollment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => authService.completeMfaEnrollment({ code }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mfa', 'status'] });
    },
  });
};

export const useDisableMfa = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => authService.disableMfa({}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mfa', 'status'] });
      toast.success('Two-factor authentication disabled');
    },
  });
};

export const useRegenerateMfaRecoveryCodes = () => {
  return useMutation({
    mutationFn: () => authService.regenerateMfaRecoveryCodes({}),
  });
};

export const useVerifyMfa = () => {
  return useMutation({
    mutationFn: (params: { mfa_challenge_token: string; method: string; code: string }) =>
      authService.verifyMfa(params),
  });
};
